import * as React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { Button, MenuItem, Tooltip } from '@blueprintjs/core';
export function SidebarItem(_a) {
    var _b = _a.collapsed, collapsed = _b === void 0 ? false : _b, _c = _a.exact, exact = _c === void 0 ? true : _c, icon = _a.icon, title = _a.title, to = _a.to, onClick = _a.onClick, label = _a.label, rightIcon = _a.rightIcon;
    var match = useRouteMatch({
        path: to,
        exact: exact
    });
    if (!collapsed) {
        return React.createElement(Link, { to: to, className: "patterns-sidebar-menu-item", component: function (props, ref) { return React.createElement(MenuItem, { active: match !== null, icon: icon, text: title, labelElement: label, onClick: function () { return onClick ? onClick() : props.navigate(ref); } }); } });
    }
    return React.createElement(Tooltip, null,
        React.createElement(Link, { to: to, className: "patterns-sidebar-menu-item collapsed", component: function (props, ref) { return React.createElement(Button, { active: match !== null, icon: icon, rightIcon: rightIcon, onClick: function () { return onClick ? onClick() : props.navigate(ref); } }); } }),
        React.createElement("span", null, title));
}
//# sourceMappingURL=sidebar_item.js.map